// Listing pages rendered with Firecrawl to find article links (knowledge-scraper design_001)
export const renderedListingSourceType = "Rendered listing"
export const sourceTypes = [
    "RSS feed",
    "Content partner",
    "Twitter account",
    "Home page",
    renderedListingSourceType,
    "Earthtime",
]
// The source fields dashboard-api's rendered_listing_check reads, so a change to any of them is checked again
export const renderedListingCheckedFields = [
    "type",
    "url",
    "link_pattern",
    "listing_urls",
    "preserve_article_links",
]
export const publicationTypes = [
    "Blogs and Articles",
    "Reports and Policy Briefs",
    "Industry Analysis",
    "Case Studies and Capacity Building",
    "Guides, Playbooks and Recommendations",
    "Data Visualizations",
    "Databases",
    "Assessment Tools and Dashboards",
]
export const defaultContentType = "Articles and Publication"
export const contentTypeLabels = {
    "Articles and Publication": "Publications",
    Podcasts: "Podcasts",
    Videos: "Videos",
    "Data Visualizations": "Data Visualizations",
}
export const sourceCountries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antartica",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "Christmas Islands",
    "Cocos (Kelling) Islands",
    "Colombia",
    "Comoros",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "Côte d'Ivoire",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Democratic People's Republic of Korea",
    "Democratic Republic of Congo",
    "Denmark",
    "Djibouti",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Falklands Islands (Malvinas)",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "Former Yugoslav Republic of Macedonia",
    "France",
    "France, Metropolitan",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard and Mc Donald Islands",
    "Honduras",
    "Hong Kong SAR",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iraq",
    "Ireland",
    "Islamic Republic of Iran",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kosovo",
    "Kuwait",
    "Kyrgyz Republic",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao SAR",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "Netherlands Antilles",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Islands",
    "Northern Cyprus",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestinian Territories",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "People's Republic of China",
    "Peru",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Republic of Korea",
    "Reunion",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and The Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "Somaliland",
    "South Africa",
    "South Georgia and the South Sandwich Islands",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "St. Helena",
    "St. Pierre and Miquelon",
    "Sudan",
    "Suriname",
    "Svalbard and Jan Mayen Islands",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan, China",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States Minor Outlying Islands",
    "Unknown",
    "Uruguay",
    "USA",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City State",
    "Venezuela",
    "Viet Nam",
    "Virgin Islands (British)",
    "Virgin Islands (U.S.)",
    "Wallis and Futuna Islands",
    "Yemen",
    "Zambia",
    "Zimbabwe",
]
export const sourceCountryToRegion = {
    Afghanistan: "South Asia",
    Albania: "Central/Eastern Europe",
    Algeria: "North Africa",
    "American Samoa": "Asia Pacific",
    Andorra: "Western Europe",
    Angola: "Sub-saharan Africa",
    Anguilla: "North America",
    Antartica: "Antarctica",
    "Antigua and Barbuda": "North America",
    Argentina: "Latin America",
    Armenia: "Central/Eastern Europe",
    Aruba: "North America",
    Australia: "Australasia",
    Austria: "Western Europe",
    Azerbaijan: "Central/Eastern Europe",
    Bahamas: "North America",
    Bahrain: "Middle East",
    Bangladesh: "South Asia",
    Barbados: "North America",
    Belarus: "Central/Eastern Europe",
    Belgium: "Western Europe",
    Belize: "Latin America",
    Benin: "Sub-saharan Africa",
    Bermuda: "North America",
    Bhutan: "South Asia",
    Bolivia: "Latin America",
    "Bosnia and Herzegovina": "Central/Eastern Europe",
    Botswana: "Sub-saharan Africa",
    "Bouvet Island": "North America",
    Brazil: "Latin America",
    "British Indian Ocean Territory": "Asia Pacific",
    "Brunei Darussalam": "Asia Pacific",
    Bulgaria: "Central/Eastern Europe",
    "Burkina Faso": "Sub-saharan Africa",
    Burundi: "Sub-saharan Africa",
    Cambodia: "Asia Pacific",
    Cameroon: "Sub-saharan Africa",
    Canada: "North America",
    "Cape Verde": "Sub-saharan Africa",
    "Cayman Islands": "North America",
    "Central African Republic": "Sub-saharan Africa",
    Chad: "Sub-saharan Africa",
    Chile: "Latin America",
    "Christmas Islands": "Asia Pacific",
    "Cocos (Kelling) Islands": "Asia Pacific",
    Colombia: "Latin America",
    Comoros: "Sub-saharan Africa",
    Congo: "Sub-saharan Africa",
    "Cook Islands": "Asia Pacific",
    "Costa Rica": "Latin America",
    "Côte d'Ivoire": "Sub-saharan Africa",
    Croatia: "Central/Eastern Europe",
    Cuba: "Latin America",
    Cyprus: "Western Europe",
    "Czech Republic": "Central/Eastern Europe",
    "Democratic People's Republic of Korea": "Asia Pacific",
    "Democratic Republic of Congo": "Sub-saharan Africa",
    Denmark: "Western Europe",
    Djibouti: "Sub-saharan Africa",
    "Dominican Republic": "Latin America",
    Ecuador: "Latin America",
    Egypt: "Middle East",
    "El Salvador": "Latin America",
    "Equatorial Guinea": "Sub-saharan Africa",
    Eritrea: "Sub-saharan Africa",
    Estonia: "Central/Eastern Europe",
    Ethiopia: "Sub-saharan Africa",
    "Falklands Islands (Malvinas)": "Latin America",
    "Faroe Islands": "Western Europe",
    Fiji: "Asia Pacific",
    Finland: "Western Europe",
    "Former Yugoslav Republic of Macedonia": "Central/Eastern Europe",
    France: "Western Europe",
    "France, Metropolitan": "Western Europe",
    "French Guiana": "Latin America",
    "French Polynesia": "Asia Pacific",
    "French Southern Territories": "Antarctica",
    Gabon: "Sub-saharan Africa",
    Gambia: "Sub-saharan Africa",
    Georgia: "Central/Eastern Europe",
    Germany: "Western Europe",
    Ghana: "Sub-saharan Africa",
    Gibraltar: "Western Europe",
    Greece: "Western Europe",
    Greenland: "Western Europe",
    Grenada: "North America",
    Guadeloupe: "North America",
    Guam: "Asia Pacific",
    Guatemala: "Latin America",
    Guinea: "Sub-saharan Africa",
    "Guinea-Bissau": "Sub-saharan Africa",
    Guyana: "Latin America",
    Haiti: "North America",
    "Heard and Mc Donald Islands": "Antarctica",
    Honduras: "Latin America",
    "Hong Kong SAR": "Greater China",
    Hungary: "Central/Eastern Europe",
    Iceland: "Western Europe",
    India: "South Asia",
    Indonesia: "Asia Pacific",
    Iraq: "Middle East",
    Ireland: "Western Europe",
    "Islamic Republic of Iran": "Middle East",
    Israel: "Middle East",
    Italy: "Western Europe",
    Jamaica: "North America",
    Japan: "Japan",
    Jordan: "Middle East",
    Kazakhstan: "Central/Eastern Europe",
    Kenya: "Sub-saharan Africa",
    Kiribati: "Asia Pacific",
    Kosovo: "Central/Eastern Europe",
    Kuwait: "Middle East",
    "Kyrgyz Republic": "Central/Eastern Europe",
    Laos: "Asia Pacific",
    Latvia: "Central/Eastern Europe",
    Lebanon: "Middle East",
    Lesotho: "Sub-saharan Africa",
    Liberia: "Sub-saharan Africa",
    Libya: "North Africa",
    Liechtenstein: "Western Europe",
    Lithuania: "Central/Eastern Europe",
    Luxembourg: "Western Europe",
    "Macao SAR": "Greater China",
    Madagascar: "Sub-saharan Africa",
    Malawi: "Sub-saharan Africa",
    Malaysia: "Asia Pacific",
    Maldives: "South Asia",
    Mali: "Sub-saharan Africa",
    Malta: "Western Europe",
    "Marshall Islands": "Asia Pacific",
    Martinique: "North America",
    Mauritania: "North Africa",
    Mauritius: "Sub-saharan Africa",
    Mayotte: "Asia Pacific",
    Mexico: "Latin America",
    Micronesia: "Asia Pacific",
    Moldova: "Central/Eastern Europe",
    Monaco: "Western Europe",
    Mongolia: "Asia Pacific",
    Montenegro: "Central/Eastern Europe",
    Montserrat: "North America",
    Morocco: "North Africa",
    Mozambique: "Sub-saharan Africa",
    Myanmar: "Asia Pacific",
    Namibia: "Sub-saharan Africa",
    Nauru: "Asia Pacific",
    Nepal: "South Asia",
    Netherlands: "Western Europe",
    "Netherlands Antilles": "North America",
    "New Caledonia": "Asia Pacific",
    "New Zealand": "Australasia",
    Nicaragua: "Latin America",
    Niger: "Sub-saharan Africa",
    Nigeria: "Sub-saharan Africa",
    Niue: "Asia Pacific",
    "Norfolk Islands": "Asia Pacific",
    "Northern Cyprus": "Western Europe",
    "Northern Mariana Islands": "Asia Pacific",
    Norway: "Western Europe",
    Oman: "Middle East",
    Pakistan: "South Asia",
    Palau: "Asia Pacific",
    "Palestinian Territories": "Middle East",
    Panama: "Latin America",
    "Papua New Guinea": "Asia Pacific",
    Paraguay: "Latin America",
    "People's Republic of China": "Greater China",
    Peru: "Latin America",
    Philippines: "Asia Pacific",
    Pitcairn: "Asia Pacific",
    Poland: "Central/Eastern Europe",
    Portugal: "Western Europe",
    "Puerto Rico": "Latin America",
    Qatar: "Middle East",
    "Republic of Korea": "Asia Pacific",
    Reunion: "Sub-saharan Africa",
    Romania: "Central/Eastern Europe",
    "Russian Federation": "Russia",
    Rwanda: "Sub-saharan Africa",
    "Saint Kitts and Nevis": "North America",
    "Saint Lucia": "North America",
    "Saint Vincent and The Grenadines": "North America",
    Samoa: "Asia Pacific",
    "San Marino": "Western Europe",
    "Sao Tome and Principe": "Sub-saharan Africa",
    "Saudi Arabia": "Middle East",
    Senegal: "Sub-saharan Africa",
    Serbia: "Central/Eastern Europe",
    Seychelles: "Sub-saharan Africa",
    "Sierra Leone": "Sub-saharan Africa",
    Singapore: "Asia Pacific",
    Slovakia: "Central/Eastern Europe",
    Slovenia: "Central/Eastern Europe",
    "Solomon Islands": "Asia Pacific",
    Somalia: "Sub-saharan Africa",
    Somaliland: "Sub-saharan Africa",
    "South Africa": "Sub-saharan Africa",
    "South Georgia and the South Sandwich Islands": "Latin America",
    "South Sudan": "Sub-saharan Africa",
    Spain: "Western Europe",
    "Sri Lanka": "South Asia",
    "St. Helena": "Sub-saharan Africa",
    "St. Pierre and Miquelon": "North America",
    Sudan: "Sub-saharan Africa",
    Suriname: "Latin America",
    "Svalbard and Jan Mayen Islands": "Western Europe",
    Swaziland: "Sub-saharan Africa",
    Sweden: "Western Europe",
    Switzerland: "Western Europe",
    Syria: "Middle East",
    "Taiwan, China": "Greater China",
    Tajikistan: "Central/Eastern Europe",
    Tanzania: "Sub-saharan Africa",
    Thailand: "Asia Pacific",
    "Timor-Leste": "Asia Pacific",
    Togo: "Sub-saharan Africa",
    Tokelau: "Asia Pacific",
    Tonga: "Asia Pacific",
    "Trinidad and Tobago": "North America",
    Tunisia: "North Africa",
    Turkey: "Central/Eastern Europe",
    Turkmenistan: "Central/Eastern Europe",
    "Turks and Caicos Islands": "North America",
    Tuvalu: "Asia Pacific",
    Uganda: "Sub-saharan Africa",
    Ukraine: "Central/Eastern Europe",
    "United Arab Emirates": "Middle East",
    "United Kingdom": "Western Europe",
    "United States Minor Outlying Islands": "North America",
    Unknown: "Unknown",
    Uruguay: "Latin America",
    USA: "North America",
    Uzbekistan: "Central/Eastern Europe",
    Vanuatu: "Asia Pacific",
    "Vatican City State": "Western Europe",
    Venezuela: "Latin America",
    "Viet Nam": "Asia Pacific",
    "Virgin Islands (British)": "North America",
    "Virgin Islands (U.S.)": "North America",
    "Wallis and Futuna Islands": "Asia Pacific",
    Yemen: "Middle East",
    Zambia: "Sub-saharan Africa",
    Zimbabwe: "Sub-saharan Africa",
}
export const regionToParentRegion = {
    "South Asia": "Asia",
    "Central/Eastern Europe": "Europe",
    "North Africa": "Middle East/North Africa",
    "Asia Pacific": "Asia",
    "Western Europe": "Europe",
    "Sub-saharan Africa": "Middle East/North Africa",
    Antarctica: "Asia",
    Australasia: "Asia",
    "Middle East": "Middle East/North Africa",
    "Greater China": "Asia",
    Japan: "Asia",
    Russia: "Europe",
}
export const licenseOptions = [
    "Summary and link through",
    "Free",
    "Acknowledgement",
    "Royalty",
    "Other",
]
export const sourceLanguages = [
    { label: "English", id: "en" },
    { label: "German", id: "de" },
    { label: "Spanish", id: "es" },
    { label: "French", id: "fr" },
    { label: "Italian", id: "it" },
    { label: "Russian", id: "ru" },
    { label: "Portuguese", id: "pt" },
    { label: "Hungarian", id: "hu" },
    { label: "Dutch", id: "nl" },
    { label: "Turkish", id: "tr" },
    { label: "Chinese", id: "zh" },
    { label: "Arabic", id: "ar" },
]
export const moderationStatuses = [
    { value: true, label: "Approved" },
    { value: false, label: "Rejected" },
    { value: "null", label: "Unmoderated" },
]
export const judgeModerationStatuses = [
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
    { value: "undecided", label: "Unmoderated" },
]
export const autopilotOptions = ["Conservative", "Full"]
export const topicDimensionStatuses = ["Active", "Draft", "Idea", "Inactive"]
export const topicTypes = [
    { plural_name: "Industries", name: "Industry" },
    { plural_name: "Economies", name: "Economy" },
    { plural_name: "Global Issues", name: "Global Issue" },
    { plural_name: "System Initiatives", name: "System Initiatives" },
    {
        plural_name: "Fourth Industrial Revolution",
        name: "4th Industrial Revolution",
    },
    { plural_name: "Custom Maps", name: "Custom Map" },
]
export const defaultAllTopicTypes = topicTypes.filter(
    ({ name }) => name !== "Custom Map"
)
export const communitySources = ["CI", "Salesforce", "TopLink"]
export const communityStatuses = ["Active", "Archive", "Draft"]
export const communityTypes = {
    inviteonly: "Invite only",
    private: "Request to join",
    public: "Open",
    unlisted: "Unlisted",
}
export const isFullscreen = false
export const itemStates = {
    added: "added",
    removed: "removed",
    updated: "updated",
}

export const personRoles = ["Expert", "Co-curator", "Innovator", "Other"]
export const organisationRoles = ["Expert", "Co-curator", "Innovator", "Other"]

export const stakeholderTypes = ["Organisation", "Person"]

export const tokenRefreshInterval = 1000 * 60 * 30 // 30 mins

export const articleRejectionReasons = [
    "Offensive content",
    "Uninteresting content",
    "Poor meta-data quality",
    "Factually inaccurate",
]

export const briefingIntroductionMessageLimit = 3500

export const notificationTypes = {
    alert: { label: "Alert", linkType: "link" },
    event: { label: "Event", linkType: "entity_id" },
    topic: { label: "Topic", linkType: "entity_id" },
    knowledge: { label: "Knowledge", linkType: "entity_id" },
    cluster: { label: "Cluster (Emerging theme)", linkType: "entity_id" },
}
